import React from 'react';
import { Link } from 'react-router-dom';
import { Map as MapIcon, Package, Shuffle, Skull } from 'lucide-react';
import { EntityThumb } from '../../world/EntityThumb';
import { itemPath, mapPath, monsterPath } from '../../../utils/worldFormat';
import { kundunBoxes, type GoldenMonster } from '../../../data/guide/goldenInvasion';
const btn = 'inline-flex h-9 items-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.03] px-2.5 text-xs font-semibold text-gray-200 transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white';

/** Tarjeta de un dorado: imagen (sin acción de clic), cantidad, mapas, caja y accesos. */
export function GoldenMonsterCard({
  m,
  mapIdFor
}: {
  m: GoldenMonster;
  mapIdFor: (name: string) => number | undefined;
}) {
  return <li className="flex h-full flex-col rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 md:p-4" data-id="element-608" data-mp="f8du0qyy5bh2">
      <div className="flex items-start gap-3" data-id="element-609" data-mp="ahnqlja2zip0">
        <EntityThumb entity={{
        type: 'monster',
        id: m.id
      }} name={m.name} size="card" placeholder fallback={<span className="flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03]" data-id="element-611" data-mp="33savbwnm0ccw"><Skull className="h-5 w-5 text-gray-500" aria-hidden="true" data-id="element-612" data-mp="38pjjqezcpcml" /></span>} data-id="element-610" data-mp="agvu868ntgxo" />
        <div className="min-w-0 flex-1" data-id="element-613" data-mp="2u053qo19rwy8">
          <h3 className="font-cinzel font-bold leading-tight text-white" data-id="element-614" data-mp="2tzc8aj7rgtve">{m.name}</h3>
          <p className="mt-0.5 text-[11px] text-gray-500" data-id="element-615" data-mp="2yyezp0utj1kw">ID {m.id}</p>
          <p className="mt-1.5 text-sm text-white" data-id="element-616" data-mp="2kzp5pu3api0r">
            <span className="font-cinzel text-lg font-black tabular-nums text-[#E8C766]" data-id="element-617" data-mp="2p23q4imm4pu5">×{m.count}</span>{' '}
            <span className="text-gray-400" data-id="element-618" data-mp="2b2khlopw3chb">por aparición</span>
          </p>
        </div>
      </div>

      <div className="mt-3 text-sm" data-id="element-619" data-mp="2g15lpz89igb1">
        {m.oneOf ? <p className="flex items-start gap-1.5 text-gray-300" data-id="element-620" data-mp="2g3hx1tjilsf4">
            <Shuffle className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-621" data-mp="9bz7475s8w9y" />
            <span data-id="element-622" data-mp="e8zfwpu0od4r">Solo 1, en <strong className="font-semibold text-white" data-id="element-623" data-mp="e8pmes9rjnub">uno</strong> de estos mapas: {m.maps.join(', ')}</span>
          </p> : <p className="text-gray-300" data-id="element-624" data-mp="cqiquta84cmj">{m.maps.join(', ')}</p>}
        <p className="mt-1.5 flex items-start gap-1.5 text-white" data-id="element-625" data-mp="7sh4nzhi3x6u">
          <Package className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-626" data-mp="2vqq5glch9nj" />
          {m.drop}
        </p>
      </div>

      <div className="mt-auto flex flex-wrap gap-1.5 pt-3" data-id="element-627" data-mp="3u2tfs3ljb7vn">
        <Link to={monsterPath(m.id)} className={btn} data-id="element-628" data-mp="vjmkwfrcsrho">
          <Skull className="h-3.5 w-3.5" aria-hidden="true" data-id="element-629" data-mp="vl7fu6hkycg2" /> Ver monstruo
        </Link>
        {m.maps.map(name => {
        const id = mapIdFor(name);
        if (id === undefined) return null;
        return <Link key={name} to={mapPath(id)} className={btn} data-id="element-630" data-mp="guqc2ghh3ag0">
              <MapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-631" data-mp="gse0cl2b5wbe" /> {m.maps.length > 1 ? name : 'Ver mapa'}
            </Link>;
      })}
        {m.boxLevels.map(lvl => {
        const b = kundunBoxes.find(k => k.level === lvl)!;
        return <Link key={lvl} to={itemPath(b.id)} className={btn} data-id="element-632" data-mp="1ht3f2vdcalal">
              <Package className="h-3.5 w-3.5" aria-hidden="true" data-id="element-633" data-mp="1lt3qe7556gdf" /> {m.boxLevels.length > 1 ? `Kundun +${lvl}` : 'Ver caja'}
            </Link>;
      })}
      </div>
    </li>;
}